const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { jobStatusType } = require('../../js/constants')
const {
  RequestRetryBackOffHelper
} = require('../../js/request-retry-backoff-helper')

angular
  .module('surfsightApp.controllers')

  .controller('edgeSpeedingReportsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeFactoryV2',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    'SystemConstants',
    'UnitSystem',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeFactoryV2,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams,
      SystemConstants,
      UnitSystem,
      NgTableParams,
      $q
    ) {
      const pageLimit = window.deviceReportPaginationLimit
      const groupId = parseInt($stateParams.edge_group_id)
      const deviceId = parseInt($stateParams.edge_id)
      const $translate = $filter('translate')
      let lastRequestQueryParams
      $scope.edge_name = ''
      const stateName = $state.current.name
      $scope.UnitSystem = UnitSystem
      $scope.UnitSystem = UnitSystem
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#device-ui-settings-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      if ($localStorage.measurementUnits === 1) {
        SystemConstants.unit = 1
      } else {
        SystemConstants.unit = 0
      }
      let timeFormat = 2
      if ($localStorage.timeFormat) {
        timeFormat = $localStorage.timeFormat
      }
      const initTable = () => {
        $scope.ngSpeedingReportTable = {
          columns: {
            dashcamName: {
              title: $translate('dashcamName')
            },
            recordedSpeed: {
              title: $translate('recordedSpeed')
            },
            time: {
              title: $translate('time')
            },
            location: {
              title: $translate('location')
            }
          },
          ngTableParams: new NgTableParams(
            {
              noPager: true,
              page: 1, // show first page
              count: pageLimit // count per page
            },
            {
              counts: [],
              filterDelay: 300,
              getData: params => {
                return new Promise((resolve, reject) => {
                  ;(async () => {
                    if ($scope.speedingReportState) {
                      $scope.speedingReportState.page = params._params.page
                      $scope.speedingReportState.limit = params._params.count
                    }
                    const {
                      tableRows,
                      totalRecords
                    } = await getEdgeReportsData()
                    params.total(totalRecords)
                    resolve(tableRows)
                  })()
                })
              }
            }
          )
        }
        $scope.reportName =
          (
            `${$scope.edge_name} ` +
            `${$translate('speedingReport')} ` +
            `(${$rootScope.reportDateRangeFilter.name_formate2}` +
            `${
              $rootScope.reportDateRangeFilter.current_year
                ? ' ' + $rootScope.reportDateRangeFilter.current_year
                : ''
            })`
          )
            .replace(/ {2}- /g, '-')
            .replace(/ {2}/g, ' ')
            .replace(/ /g, '-') + '.csv'
      }
      const initReport = () => {
        $timeout(() => {
          initTable()
        })
      }
      $scope.showSearchOption = () => !deviceId
      $scope.speedingReportState = {
        searchText: '',
        page: 1,
        limit: pageLimit,
        totalCount: 0,
        dashcam: []
      }
      if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
          initReport()
        } else {
          const requestId = window.makeId(5)
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', {
            id: deviceId,
            requestId
          })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', (e, data) => {
            if (data.id === deviceId && data.requestId === requestId) {
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
              initReport()
            }
          })
        }
      } else if (
        [
          'home.common.reports.edgegroup',
          'home.common.reports.edgegroupreportDashboard'
        ].includes(stateName)
      ) {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
          initReport()
        } else {
          let group = edgeGroupFactory.list.find(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
            initReport()
          } else {
            const requestId = window.makeId(5)
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', {
              id: groupId,
              requestId
            })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', (e, data) => {
              if (data.id === groupId && data.requestId === requestId) {
                group = edgeGroupFactory.list.find(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
                initReport()
              }
            })
          }
        }
      }
      // mobile screens
      if (
        [
          'home.common.reports.edgegroupreportDashboard',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        if (!$rootScope.reportDateRangeFilter) {
          // page does not have search filter information. Redirect
          if (groupId) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: groupId
            })
          } else {
            $state.go('home.common.reports.edge', { edge_id: deviceId })
          }
        }
      }
      let searchTextTimer
      $scope.trackSearchText = () => {
        if (deviceId) return
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.speedingReportState = {
            searchText: $scope.speedingReportState.searchText,
            page: 1,
            limit: pageLimit,
            totalCount: 0,
            dashcam: []
          }
          $scope.ngSpeedingReportTable.ngTableParams
            .parameters({ page: 1 })
            .reload()
        }, 1500)
      }
      $scope.$on('eventSearchDataResult', (e, data) => {
        $scope.ngSpeedingReportTable.ngTableParams
          .parameters({ page: 1 })
          .reload()
      })
      const getEdgeReportsData = async () => {
        const startTime = $rootScope.reportDateRangeFilter.date.start / 1000
        const endTime = $rootScope.reportDateRangeFilter.date.end / 1000
        const { page, limit, searchText } = $scope.speedingReportState
        const queryParams = new URLSearchParams()
        queryParams.append('startTime', startTime)
        queryParams.append('endTime', endTime)
        queryParams.append('searchText', searchText)
        queryParams.append('limit', limit)
        queryParams.append('page', page)
        lastRequestQueryParams = `${queryParams.toString()}&organizationId=${
          $rootScope.currentUserOrganization.id
        }&groupId=${groupId}`
        let url
        if (deviceId && $scope.edge) {
          url = `${EDGE_BASEURL}/device/${
            $scope.edge.uri
          }/speeding-report?${queryParams.toString()}`
        } else {
          url = `${EDGE_BASEURL}/organization/${
            $rootScope.currentUserOrganization.id
          }/group/${groupId}/speeding-report?${queryParams.toString()}`
        }
        const requestJson = {
          method: 'GET',
          url
        }
        const groupSpeedingReportResponse = await $http(requestJson)
        const {
          devicesSpeedingReport,
          totalCount
        } = groupSpeedingReportResponse.data

        const devicesSpeedingReportParsed = devicesSpeedingReport.map(
          deviceSpeedingReport => ({
            id: deviceSpeedingReport.deviceId,
            name: deviceSpeedingReport.name,
            lat: deviceSpeedingReport.lat,
            lon: deviceSpeedingReport.lon,
            speed: UnitSystem.value(deviceSpeedingReport.speed, 'km/h', '$v$l'),
            location: '',
            time_string: new Date(deviceSpeedingReport.time * 1000).toString(
              timeFormat === 1 ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy hh:mm tt'
            ),
            eventData: deviceSpeedingReport
          })
        )
        const devicesSpeedingReportLocations = await Promise.all(
          devicesSpeedingReport.map(deviceSpeedingReport =>
            nominatimLookUp.reverseLookup({
              lat: deviceSpeedingReport.lat,
              lon: deviceSpeedingReport.lon
            })
          )
        )

        devicesSpeedingReportLocations.forEach((locationDetails, index) => {
          devicesSpeedingReportParsed[index].location =
            locationDetails.title || ''
        })
        return {
          tableRows: devicesSpeedingReportParsed,
          totalRecords: totalCount
        }
      }
      const showEventsModal = async (_deviceId, deviceEvent) => {
        try {
          const edge = edgeFactory.list.find(e => e.id === _deviceId)
          // invoking this to get isBlurringEnabled flag to show conceal icon
          const deviceData = edgeFactoryV2.findItemByImei(edge.uri)
          let device
          if (!deviceData.item) {
            device = await edgeFactoryV2.getSingleDevice(
              edge.organizationId,
              edge.uri
            )
          } else {
            device = deviceData.item
          }
          edge.isBlurringEnabled = device.isBlurringEnabled || false
          $mdDialog.show({
            locals: {
              dataFromCaller: {
                edge: edge,
                edge_event: deviceEvent
              }
            },
            controller: 'EdgeEventVideosController',
            templateUrl:
              './templates/edge.event.videos.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
        } catch (error) {
          console.error('showEventsModal', error)
        }
      }
      const [speedLimitEventSetting] = deviceEventSettings.filter(
        eventSetting => eventSetting.name === 'SpeedLimit'
      )
      $scope.speedingDatatableRowClicked = eventData => {
        showEventsModal(eventData.deviceId, {
          id: eventData.id,
          msg_type: 'SpeedLimit',
          lat: eventData.lat,
          lon: eventData.lon,
          speed: eventData.speed,
          time: eventData.time,
          edge_setting: speedLimitEventSetting,
          time_string_formate: new Date(eventData.time * 1000).toString(
            'h:mm:ss tt MMM dd yyyy'
          )
        })
      }
      $scope.showReportDateFilter = e => {
        $scope.$emit('SHOW_REPORT_DATE_FILTER_EMIT', { event: e })
      }
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestId: '',
          downloadRequestStatus: jobStatusType.INITIAL,
          downloadUrl: ''
        }
      }
      $scope.resetCurrentReportDownload()
      const retryCurrentReportDownload = async (
        signal = new AbortController()
      ) => {
        const requestTimeout = $q.defer()
        signal.addEventListener('abort', () => {
          requestTimeout.resolve()
        })
        $scope.downloadStatus.downloadRequestId = ''
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        const requestRetryBackOffIterator = new RequestRetryBackOffHelper(
          50,
          5,
          true,
          30
        ).getIterator()
        for await (const { attempts } of requestRetryBackOffIterator) {
          try {
            if (signal.aborted) break
            const queryParams = new URLSearchParams(
              attempts > 1
                ? {
                    downloadRequestId: $scope.downloadStatus.downloadRequestId
                  }
                : lastRequestQueryParams
            )
            ;['page', 'limit'].forEach(param => {
              queryParams.delete(param)
            })
            const requestJson = {
              method: 'GET',
              url:
                EDGE_BASEURL +
                '/speeding-report-download?' +
                queryParams.toString(),
              timeout: requestTimeout
            }
            const response = await $http(requestJson)
            if (response.data) {
              const downloadRequestStatus = response.data.downloadStatus
              if (attempts === 1) {
                $scope.downloadStatus.downloadRequestId =
                  response.data.downloadRequestId
              }
              if (downloadRequestStatus) {
                $scope.downloadStatus.downloadRequestStatus = downloadRequestStatus
                if (
                  downloadRequestStatus === jobStatusType.COMPLETED ||
                  signal.aborted
                ) {
                  $scope.downloadStatus.downloadUrl = response.data.url
                  triggerDownload($scope.downloadStatus.downloadUrl)
                  break
                }
                if (downloadRequestStatus === jobStatusType.FAILED) {
                  throw new Error(response.data.status.error)
                }
              }
            }
          } catch (ex) {
            console.error(ex)
            $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            $scope.showMessageToast(ex.data.status.error)
            break
          }
          $scope.$apply()
        }
        $scope.$apply()
      }
      function triggerDownload (url) {
        const a = document.createElement('a')
        a.href = url
        a.download = ''
        a.style.display = 'none'
        document.body.appendChild(a)

        a.click()
        document.body.removeChild(a)
      }
      let previousDownloadRequestAbortController = new AbortController()
      $scope.downloadCurrentReport = () => {
        if (
          previousDownloadRequestAbortController &&
          !previousDownloadRequestAbortController.signal.aborted
        ) {
          previousDownloadRequestAbortController.abort()
        }
        previousDownloadRequestAbortController = new AbortController()
        retryCurrentReportDownload(
          previousDownloadRequestAbortController.signal
        )
      }
      $scope.exportReport = () => {
        $scope.ngSpeedingReportTable.ngTableParams.settings().$loading = true
        const headers = {
          dashcamName: $translate('dashcamName'),
          recordedSpeed: $translate('recordedSpeed'),
          time: $translate('time'),
          location: $translate('location')
        }
        const report = $scope.ngSpeedingReportTable.ngTableParams.data.map(
          tableRow => {
            return {
              [headers.dashcamName]: tableRow.name || $scope.edge_name,
              [headers.recordedSpeed]: tableRow.speed,
              [headers.time]: tableRow.time_string,
              [headers.location]: tableRow.location
            }
          }
        )
        $scope.ngSpeedingReportTable.ngTableParams.settings().$loading = false
        return report
      }
    }
  ])
